import type { ComponentProps } from "react";

import { Link2 } from "@/ui2/atoms/Link";

type SupportLinkProps = ComponentProps<typeof Link2>;

export function SupportLink(props: SupportLinkProps) {
  return <Link2 className="tw:mx-0.5ch" rawChildren size="sm" {...props} />;
}
